import React from 'react';
import PropTypes from 'prop-types';
import omit from 'lodash-es/omit';
import styles from './TextInput.module.scss';

export default function TextInput(props) {
  const classes = [
    props.className,
    styles.textInput,
    props.fullWidth ? styles.fullWidth : ''
  ].join(' ');

  return (
    <input {...omit(props, ['fullWidth'])} type="text" className={classes}/>
  );
}

TextInput.propTypes = {
  className: PropTypes.string,
  fullWidth: PropTypes.bool,
};
